import qs from 'qs';

export type CheckInType = 'qr_code';

export const parseCheckInType = (str: string): CheckInType | null => {
  switch (str) {
    case 'qr_code':
      return 'qr_code';
    default:
      return null;
  }
};

export const parseCheckInDataFromQueryString = (
  queryString: string,
): {
  type: CheckInType;
  id: number;
} | null => {
  const {checkin: checkinData} = qs.parse(queryString, {
    ignoreQueryPrefix: true,
  });

  if (
    !checkinData ||
    Array.isArray(checkinData) ||
    typeof checkinData !== 'object'
  )
    return null;

  if (!('type' in checkinData) || !('id' in checkinData)) return null;
  if (
    typeof checkinData.type !== 'string' ||
    typeof checkinData.id !== 'string'
  )
    return null;

  const type = parseCheckInType(checkinData.type);
  const id = parseInt(checkinData.id, 10);

  if (!type || Number.isNaN(id)) return null;

  return {
    type,
    id,
  };
};
